import { collection, getDocs, getDoc, doc } from 'firebase/firestore';

function getCollectionsForLang(lang) {
  const isEs = (lang || '').toLowerCase().startsWith('es');
  return {
    dataCollection: isEs ? 'hpc_data_es' : 'hpc_data',
    fieldsCollection: isEs ? 'hpc_fields_es' : 'hpc_fields',
  };
}

export async function fetchHpcDataAndFields(db, lang) {
  const { dataCollection, fieldsCollection } = getCollectionsForLang(lang);

  // Programs data
  let docsData = [];
  try {
    const snap = await getDocs(collection(db, dataCollection));
    if (!snap || typeof snap.forEach !== 'function') {
      throw new Error(`Invalid snapshot for ${dataCollection}`);
    }
    snap.forEach((d) => {
      const v = d.data();
      v.id = d.id;
      docsData.push(v);
    });
  } catch (e) {
    console.error("Error fetching data:", e);
    // fallback to English
    if (dataCollection !== 'hpc_data') {
      const snap = await getDocs(collection(db, 'hpc_data'));
      if (!snap || typeof snap.forEach !== 'function') {
        throw new Error('Invalid snapshot for hpc_data');
      }
      snap.forEach((d) => {
        const v = d.data();
        v.id = d.id;
        docsData.push(v);
      });
    } else {
      // No fallback available: propagate so UI shows error (as tests expect)
      throw e;
    }
  }

  // Fields/config
  let fieldsData = null;
  try {
    const fieldsDocRef = doc(db, fieldsCollection, 'columns');
    const fieldsSnapshot = await getDoc(fieldsDocRef);
    if (!fieldsSnapshot || typeof fieldsSnapshot.data !== 'function') {
      throw new Error(`Invalid fields snapshot for ${fieldsCollection}`);
    }
    fieldsData = fieldsSnapshot.data();
  } catch (e) {
    // ignore here; try fallback below or propagate if none available
  }
  if (!fieldsData && fieldsCollection !== 'hpc_fields') {
    try {
      const fieldsDocRef = doc(db, 'hpc_fields', 'columns');
      const fieldsSnapshot = await getDoc(fieldsDocRef);
      if (!fieldsSnapshot || typeof fieldsSnapshot.data !== 'function') {
        throw new Error('Invalid fields snapshot for hpc_fields');
      }
      fieldsData = fieldsSnapshot.data();
    } catch (e) {
      // Fallback also failed: propagate so UI shows error (as tests expect)
      throw e;
    }
  } else if (!fieldsData && fieldsCollection === 'hpc_fields') {
    // No fallback available: propagate an error so UI shows error (as tests expect)
    throw new Error('Failed to load fields data');
  }

  return { hpcData: docsData, fieldsData };
}
